import { colors as themeColors } from '../../../utils/theme';
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Grid, TextField, Button, Card, CardContent, CardHeader, Typography, Divider, Container, Alert, } from '@mui/material';
import axios from 'axios';
import { useAuth } from '../../../context/AuthContext';

const TransportMaster = ({ mode = 'add', id, onPopupCancel, connectionString }) => {
    const { user, selectedCompany, loading } = useAuth();
    const path = `${connectionString}/api`;
    // const { id } = useParams();
    const navigate = useNavigate();

    const [transporterName, setTransporterName] = useState('');
    const [gstNo, setGstNo] = useState('');
    const [gstError, setGstError] = useState('');
    const [formError, setFormError] = useState('');

    const username = user?.emailId;
    const companyId = selectedCompany?.CompId || null;
    const fYear = selectedCompany?.financialYear;
    const userId = user?.UserId || null;

    // Load existing data if editing
    useEffect(() => {
        if (mode === 'edit' && id) {
            axios.get(`${path}/transport/getDetails/${id}`)
                .then(res => {
                    setTransporterName(res.data.TransporterName || '');
                    setGstNo(res.data.GSTNO || '');
                })
                .catch(err => console.error('Error fetching transporter:', err));
        }
    }, [id, mode]);

    // Validate GST Format
    const validateGST = (gst) => {
        const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        return gst && !regex.test(gst) ? 'Invalid GST No' : '';
    };

    const handleGSTBlur = () => { setGstError(validateGST(gstNo)); };

    const handleReset = () => {
        if (onPopupCancel) {
            onPopupCancel();
        } else {
            navigate('/main/transportDetail');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const gstValidation = validateGST(gstNo);
        setGstError(gstValidation);

        if (gstValidation || !transporterName) {
            setFormError('Please fill required fields correctly.');
            return;
        }

        const basePayload = {
            TransporterName: transporterName,
            GSTNO: gstNo,
            companyId,
            fYear,
            branchId: selectedCompany?.BranchId || null
        };

        let payload;

        if (mode === 'add') {
            payload = {
                ...basePayload,
                addUserId: user?.UserId || null   // ✅ REQUIRED FOR INSERT
            };
        } else {
            payload = {
                ...basePayload,
                editUserId: user?.UserId || null  // ✅ REQUIRED FOR UPDATE
            };
        }


        try {
            if (mode === 'add') {
                await axios.post(`${path}/transport/Insert`, payload);
                setTransporterName('');
                setGstNo('');
            } else if (mode === 'edit') {
                await axios.put(`${path}/transport/Update/${id}`, payload);
            }

            if (onPopupCancel) {
                onPopupCancel({ success: true, message: mode === 'add' ? "Transporter added successfully" : "Transporter updated successfully" });
                return;
            };
        } catch (err) {
            console.error('Error saving transporter:', err);
            setFormError('Something went wrong while saving. Please try again.');
        }
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 4 }}>
            <Card elevation={3}>
                <CardHeader title={mode === 'add' ? 'Add Transporter' : 'Edit Transporter'} sx={{ backgroundColor: themeColors.neutral.surfaceMuted, textAlign: 'center' }} />
                <Divider />
                <CardContent>
                    <form onSubmit={handleSubmit} noValidate>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <TextField label="Transporter Name" value={transporterName} onChange={(e) => setTransporterName(e.target.value)} fullWidth required />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField label="GST Number" value={gstNo} onChange={(e) => setGstNo(e.target.value)} onBlur={handleGSTBlur} fullWidth error={!!gstError} helperText={gstError} />
                            </Grid>

                            {formError && (
                                <Grid item xs={12}>
                                    <Alert severity="error">{formError}</Alert>
                                </Grid>
                            )}

                            <Grid item xs={12}>
                                <Box display="flex" justifyContent="flex-end" gap={2}>
                                    <Button variant="outlined" color="secondary" onClick={handleReset}> Cancel </Button>
                                    <Button variant="contained" color="primary" type="submit">
                                        {mode === 'add' ? 'Save' : 'Update'}
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </Container>
    );
};

export default TransportMaster;